import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { Footer } from "@/components/Footer";

const AUTH_IMG = "https://images.pexels.com/photos/950241/pexels-photo-950241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(identifier, password);
    setLoading(false);
    if (ok) navigate("/dashboard");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 relative pb-12" data-testid="login-page">
      <div className="flex items-center justify-center px-6 py-12 bg-white">
        <div className="w-full max-w-sm fade-up">
          <div className="overline mb-3">Cashflow OS</div>
          <h1 className="font-display text-4xl font-bold tracking-tighter text-[#0F172A] mb-2">Welcome back.</h1>
          <p className="text-sm text-[#6B7280] mb-10">Sign in to manage your business cash flow.</p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="identifier" className="text-xs uppercase tracking-wider text-[#4B5563] font-semibold">Email or User ID</Label>
              <Input id="identifier" type="text" autoComplete="username" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required
                data-testid="login-email-input"
                placeholder="you@example.com or your user-id"
                className="rounded-none border-[#E5E7EB] focus-visible:ring-0 focus-visible:border-[#0F172A] h-11" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-xs uppercase tracking-wider text-[#4B5563] font-semibold">Password</Label>
              <PasswordInput id="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required
                testid="login-password-input"
                className="rounded-none border-[#E5E7EB] focus-visible:ring-0 focus-visible:border-[#0F172A] h-11" />
            </div>
            {error && <div className="text-xs text-[#EF4444]" data-testid="login-error">{error}</div>}
            <Button type="submit" disabled={loading} data-testid="login-submit-button"
              className="w-full h-11 rounded-none bg-[#0F172A] hover:bg-[#1E293B] text-white text-sm font-semibold uppercase tracking-wider">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>

          <div className="mt-6 p-4 border border-[#E5E7EB] bg-[#F9FAFB] text-xs text-[#6B7280]" data-testid="contact-block">
            <div className="overline mb-1">Contact Us!</div>
            <div><a href="mailto:aiqtechofficial@gmail.com" className="text-[#0F172A] font-semibold hover:underline" data-testid="contact-email">aiqtechofficial@gmail.com</a></div>
          </div>
        </div>
      </div>
      <div className="relative hidden lg:block">
        <img src={AUTH_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0F172A]/40" />
        <div className="absolute inset-0 flex flex-col justify-end p-12 text-white">
          <div className="overline text-white/70 mb-3">PKR · Cash Flow · Ledger</div>
          <h2 className="font-display text-5xl font-bold leading-tight tracking-tighter max-w-md">
            Every rupee in. Every rupee out. Accounted for.
          </h2>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 bg-white">
        <Footer />
      </div>
    </div>
  );
}
